import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useSocketSelector } from 'js/store/hooks';

import { STACK } from '../../../../constants';
import { pushDispatcher } from '../../../usePushSubscription';
import * as constants from './constants';
import * as actions from '../../store/actions';

export const useOnForceReconnect = () => {
    const dispatch = useDispatch();
    const connection = useSocketSelector(prop('connection'));
    const [forceReconnectNeeded, setForceReconnectNeeded] = useState(false);

    useEffect(() => {
        if (!connection) {
            return;
        }

        setForceReconnectNeeded(false);
    }, [connection]);

    useEffect(() => {
        const handler = () => setForceReconnectNeeded(true);

        pushDispatcher.on(constants.FORCE_RECONNECT_ID, handler);

        return () => {
            pushDispatcher.off(constants.FORCE_RECONNECT_ID, handler);
        };
    }, []);

    useEffect(() => {
        if (forceReconnectNeeded && STACK.length === 0) {
            // force reconnect by resetting connection
            dispatch(actions.setConnectedAction(false));
            dispatch(actions.unsetConnectionAction());
        }
    }, [dispatch, forceReconnectNeeded]);
};
